import { useEffect } from 'react'

export const useOnOutsideClick = (
  ref: React.RefObject<HTMLDivElement | null>,
  callback: () => void,
  dependencies: unknown[] = [],
  skipFor?: React.RefObject<HTMLElement | null>[],
) =>
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        !skipFor?.some((item) => item.current?.contains(event.target as Node))
      ) {
        callback()
      }
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [...dependencies])
